import { createAsyncThunk } from "@reduxjs/toolkit";

import { setClickedTableRow } from "slices/ribbon";
import { somActions } from "slices/som/somSlice";

import { updateSomOffer } from "./updateSomOffer";
import { updateSourceData } from "./updateSourceData";

export const editSomItem = createAsyncThunk("som/editSomItem", async ({ itemId, body }, { rejectWithValue, extra, dispatch, getState }) => {
	const state = getState().som;

	try {
		const { data } = await extra.apiSom.editItem({ itemId, body });

		if (!data) {
			throw new Error();
		}

		dispatch(somActions.setLastClickedRow({}));

		dispatch(
			somActions.setCurItem({
				...data,
				offers: updateSomOffer({ state, payload: data }),
				source_data: updateSourceData({ state, payload: data }),
			})
		);

		if (["ADD", "EDIT"].includes(data?.change_info?.action) && data?.change_info?.object_type === "offer" && data?.change_info?.object_id) {
			const selectedObj = data?.offers?.find((x) => x.id === data?.change_info?.object_id);
			if (selectedObj) dispatch(setClickedTableRow(selectedObj));
		} else if (
			["ADD", "EDIT"].includes(data?.change_info?.action) &&
			data?.change_info?.object_type === "source_data" &&
			data?.change_info?.object_id
		) {
			const selectedObj = data?.source_data?.find((x) => x.id === data?.change_info?.object_id);
			if (selectedObj) dispatch(somActions.setLastClickedRow(selectedObj));
		}

		return data;
	} catch (e) {
		return rejectWithValue(e);
	}
});
